import React from "react";
import { Helmet } from "react-helmet-async";
import TopNavbar from "@/components/layout/TopNavbar";
import HeroSection from "@/components/home/HeroSection";
import FeatureCards from "@/components/home/FeatureCards";
import GlobalSearchDemo from "@/components/home/GlobalSearchDemo";
import DayInLifeSection from "@/components/home/DayInLifeSection";
import DashboardPreview from "@/components/home/DashboardPreview";
import FeaturesCheckList from "@/components/home/FeaturesCheckList";
import CTASection from "@/components/home/CTASection";
import Footer from "@/components/home/Footer";
import { useAuthRedirect } from "@/hooks/useAuthRedirect";

const Index = () => {
  // Add this hook to check for auth tokens and redirect as needed
  useAuthRedirect();

  return (
    <div className="min-h-screen bg-white relative">
      <Helmet>
        <title>Hivetivity - The Only Youth Program Software with Global Search</title>
        <meta name="description" content="Complete youth program management with HiveShare secure video sharing, Bill Assist AI billing intelligence, HivePad task management, electronic signatures, and a parent portal that saves 15+ hours weekly." />
        <meta name="keywords" content="youth program management, HiveShare video sharing, Bill Assist AI billing, HivePad task management, electronic signatures, parent portal, dance studio software, summer camp management, music school software, class scheduling, form designer, check-in kiosk" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://hivetivity.com/" />
        <meta property="og:title" content="Hivetivity - The Only Youth Program Software with Global Search" />
        <meta property="og:description" content="Complete youth program management with HiveShare secure video sharing, Bill Assist AI billing intelligence, HivePad task management, electronic signatures, and a parent portal that saves 15+ hours weekly." />
        <meta property="og:image" content="https://media.hivetivity.com/5fff72ca-3d1a-4a3a-be8b-093ff22772a8.png" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://hivetivity.com/" />
        <meta property="twitter:title" content="Hivetivity - The Only Youth Program Software with Global Search" />
        <meta property="twitter:description" content="Complete youth program management with HiveShare secure video sharing, Bill Assist AI billing intelligence, HivePad task management, electronic signatures, and a parent portal that saves 15+ hours weekly." />
        <meta property="twitter:image" content="https://media.hivetivity.com/5fff72ca-3d1a-4a3a-be8b-093ff22772a8.png" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://hivetivity.com/" />

        {/* Site Name Structured Data for Google Search */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Hivetivity",
            "url": "https://hivetivity.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://hivetivity.com/?q={search_term_string}",
              "query-input": "required name=search_term_string"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Hivetivity",
              "logo": {
                "@type": "ImageObject",
                "url": "https://media.hivetivity.com/0726ef88-964f-4f26-b727-362bf1f5d594.png"
              }
            }
          }
        `}</script>
      </Helmet>
      
      {/* Top Navigation */}
      <TopNavbar />
      
      {/* Main content with padding to account for fixed navbar */}
      <div className="pt-16 relative z-10">
        <HeroSection />
        <FeatureCards />
        <GlobalSearchDemo />
        <DayInLifeSection />
        <DashboardPreview />
        <FeaturesCheckList />
        <CTASection />
        <Footer />
      </div>
    </div>
  );
};

export default Index;
